import React, {useEffect, useState} from 'react';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonTitle,
  IonToolbar,
  createGesture
} from '@ionic/react';
import {chevronBackOutline, createOutline, refreshOutline} from 'ionicons/icons';
import {RefresherEventDetail} from '@ionic/core';
//Google Analytics:
import {getAnalytics, logEvent} from 'firebase/analytics';
import {initializeApp} from "firebase/app";
import Toolbar from './Toolbar';
import Nav from './Nav';
import {ApiService} from "../api/ApiService";
import arrowImg from '../imgs/arrow-right.png'
import {toastStore} from "../components/AppToast";
import {DriverProfile} from "../api/model/DriverProfile";
import {UserState, userStore} from "../api/AuthService";
import {useHistory} from "react-router-dom";

import InboxMessageBox from '../components/dialog/InboxMessageBox';
import { SidenavState, sidnavStore } from '../api/SidenavStore';

type messageChain = {
  time: string;
  message: string;
  from: string;
}

interface Message {
  id: number;
  conversationId: number;
  fromUsername: string;
  fromUserId: number;
  toUsername: string;
  toUserId: number;
  time: string;
  subject: string;
  body: string;
  type: string;
  unread_icon: any;
  read_icon: any;
  retrieved: boolean;
  linked_messages: messageChain[]
}

const firebaseConfig = {
	apiKey: "AIzaSyDE8xEN_qtMPO-aBkTon7S7kKcyUZJD5gc",
	authDomain: "western-express-5002c.firebaseapp.com",
	databaseURL: "https://western-express-5002c.firebaseio.com",
	projectId: "western-express-5002c",
	storageBucket: "western-express-5002c.appspot.com",
	messagingSenderId: "799211811572",
	appId: "1:799211811572:web:34706f63a8621cb0b0a4a1",
	measurementId: "G-V5MNJV768B"
}
 
const app = initializeApp(firebaseConfig)
 
const handleEventLog = (eventType: string, info: string) => {
	const analytics = getAnalytics(app);
	logEvent(analytics , eventType, {eventType: info})
	console.log(eventType);
}

let activeMsg: any = {}

const Inbox: React.FC = () => {

  const history = useHistory();
  const {userInfo}: { userInfo: DriverProfile } = userStore((state: UserState) => ({userInfo: state.driver}));
  const {open, close}: { open: boolean, close: () => void } = sidnavStore((state: SidenavState) => ({open: state.open, close: state.close}));
  const {toggleSidenav}: { toggleSidenav: () => void } = sidnavStore((state: SidenavState) => ({toggleSidenav: state.toggle}));

  const ref = React.useRef<HTMLInputElement>(null)

  const [msgData, setMsgData] = useState<any>([]);
  const [allMessages, setAllMessages] = useState<any>([]);
  // const [activeMsg, setActiveMsg] = useState<any>({});
  const [newMessage, setNewMessage] = useState(false);
  const [messages, setMessages] = useState<any>([]);
  const [showMessage, setShowMessage] = useState<boolean>(false)
  const [val, setVal] = useState("unread");
  const [text, setText] = useState<string>('');
  const [type, setType] = useState<string>('')
  const [sqlLength, setSqlLength] = useState<number>(20);
  const [sqlQueryStart, setSqlQueryStart] = useState<number>(0)
  const [subject, setSubject] = useState<string>('');
  const [activeFromUserArray, setActiveFromUserArray] = useState<any>([])
  const [newToUser, setNewToUser] = useState<string>("driver manager");
  const [msgHistory, setMsgHistory] = useState<any>([]);

  useEffect(() => {
    gestureInit();
    getConversations()
    ApiService.sendEventCommand("Inbox View", "eventCheck", "User has checked their inbox");
    checkForUpdates()
  }, []);
  
  const checkForUpdates = () => {
    setInterval(() => {
      getConversations();
      if (Object.keys(activeMsg).length !== 0) {
        openMessage(activeMsg)
      }
    }, 30000);
  }

  const gestureInit = () => {
      const card = ref.current
      if (card) {
          const gesture = createGesture({
              el: card,
              gestureName: 'swipeMenu',
              onMove: (detail) => {
                  // console.log("moving");
              },
              onEnd: (detail) => {
                  // console.log("move ended");
                  toggleSidenav()
              }                 
          })
          gesture.enable();
      }
  }

  function handleMode (value: boolean) {
    history.push('/home?search=true');
  }

  function getConversations() {
    ApiService.chatConversationGet("Inbox", {}).then(it => {
      processConversations(it)
    })
  }

  function processConversations(convData: any) {
    let tempConversations = [];
    for (let i = 0; i < convData.length; i++) {
      let msg: any = {}
      let tempArray: any = []
      msg.messageId = convData[i].id;
      msg.toUsername = convData[i].participants.filter((it: any) => it === localStorage.getItem('username'))
      msg.participants = convData[i].participants.filter((it: any) => it !== localStorage.getItem('username'))
      msg.fromUsernameArray = getNameObject(convData[i].participants, convData[i].pnames)
      msg.time = convData[i].updated.replace('T', ' ').replace('Z', '').replace('.000', '')
      msg.lastMessage = convData[i].lastMessage.body
      msg.unreadMessage = convData[i].lastMessage.read === 1 ? false : true;
      tempConversations.push(msg)
    }
    tempConversations.sort(function(x: {time: string | number | Date;}, y: {time: string | number | Date;}) {
      return new Date(y.time).getTime() - new Date(x.time).getTime()
    })
    setMessages(tempConversations)
  }

  function getNameObject(participants: any, names: any) {
    console.log("participants and names", participants, names);
    let tempArray: any = [];
    participants.forEach((element: any) => {
        if (element !== localStorage.getItem("username")) {             
            let index = participants.indexOf(element)
            let tempObj = {
                participant: element,
                name: names[index]
            }
            tempArray.push(tempObj)
        }
    });
    console.log("tempArray", tempArray);
    return tempArray
  }
  
  function openMessage(msg: any) {
    activeMsg = msg;
    ApiService.chatMessagesGet("Inbox", {conversationId: msg.messageId, start: sqlQueryStart, length: 20})
    .then(it => {processMsg(it, msg); setSqlQueryStart(sqlQueryStart + 20)})
    .catch(it => {
      console.log("error", it)
    })
  }
  
  async function processMsg(result: any, msg: any) {
    let messages = result.messages
    let lm: any = [];
    for (let i = 0; i < messages.length; i++) {
      lm.push({time: messages[i].posted.replace('T', ' ').slice(0,-8), message:messages[i].body, from: messages[i].author, id: messages[i].id})
    }
    lm.sort((a: { id: number; },b: { id: number; }) => a.id - b.id);
    msg.linked_messages = lm;
    if(msgData.length === 0) {
      setMsgData(msg.linked_messages);
    } else {
      let tempArray: any = msgData
      tempArray.unshift(...msg.linked_messages)
      setMsgData(tempArray);
    }
    if (msgHistory.length === 0) {
      setMsgHistory(await messageHistory(msg.linked_messages));
    } else {
      let tempArray: any = msgHistory
      tempArray.unshift(...(await messageHistory(msg.linked_messages)))
      setMsgHistory(tempArray);
    }
    setActiveFromUserArray(msg.fromUsernameArray);
    window.scrollTo(0, document.body.scrollHeight);
    getConversations();
  }

  function sendAlert() {
    // This call was commented before refactor
    // const body = 'Driver ' + userInfo.driverCode + ' has sent a new message. ' + "Use the Admin console messaging to reply to this driver: " + 'http://software.westernexp.com/admin-console/messaging';
    // ApiService.sendEmail({to: [userInfo.dmEmail], subject: 'New driver message', body}).then(() => toastStore.getState().setSuccessToast('Your message has been sent'));
  }

  async function addMessageToHistory(body: any, date: string) {
    let array: any = msgData;
    const newMsg: messageChain = { time: "just now", message: body, from: userInfo.driverCode };
    // console.log("arrays and newMsg", msgData, newMsg);
    array.push(newMsg);
    const tempArray = await messageHistory(array)
    let tempObj: any = msgData
    // tempObj = tempArray
    // console.log("messageHistory", tempObj, tempArray);
    setMsgData(tempObj);
    setMsgHistory(tempArray);
    window.scrollTo(0, document.body.scrollHeight);
  }

  function sendMessage(args: {
    body: string,
    photoId?: number,
    fromUsername: string,
    toUsername?: string,
    conversationId: number
  }) {
    // console.log("args", args)
    const sentDate = (new Date()).toJSON();
    ApiService.chatConversationPost("Inbox", args).then(() => {
      sendAlert();
      getConversations();
      ApiService.sendEventCommand("Sent Message", "eventCheck", "User has sent a message");
      addMessageToHistory(args.body, sentDate);
      setText("")
    });
  }

  function checkConversations() {
    let tempArray: any = [];
    let tempToUser: any = [newToUser]
    let hasFoundConvo: boolean = false;
    if(tempToUser[0].indexOf("driver manager") !== -1) {
      tempToUser = [userInfo.dmEmail.toUpperCase()]
    }
    // console.log("messages", tempToUser, messages)
    messages.forEach((element: any) => {
      if (JSON.stringify(element.fromUsernameArray.sort()) === JSON.stringify(tempToUser.sort())) {
        // console.log("temp Array", element, tempToUser);
        let args = {
          body: text,
          fromUsername: userInfo.driverCode,
          conversationId: element.messageId,
        }
        sendMessage(args);
        hasFoundConvo = true;
      }
    });
    if (hasFoundConvo === false) {
      createNewConversation();
    }
    // console.log("tempArray", tempArray);
    setShowMessage(false);
    setNewMessage(false)
  }

  function createNewConversation() {
    ApiService.chatConversationCreate("Inbox", {})
    .then(it => {addUsers(it)})
  }

  function addUsers(chatId: any) {
    ApiService.chatUserAdd("Inbox", {conversationId: chatId.conversationId, username: localStorage.getItem("username")!})
    ApiService.chatUserAdd("Inbox", {conversationId: chatId.conversationId, username: newToUser})
    .then(it => {
      let args = {
          body: text,
          fromUsername: localStorage.getItem("username")!,
          conversationId: chatId.conversationId,
      }
      sendMessage(args)})
  }

  const messageHistory = async (msgArray: any) => {
    let msgElement: any = await (msgArray.map(function(element: any) {
      let direction = element.from === userInfo.driverCode ? "right" : "left"
      let color = element.from === userInfo.driverCode ? "primary" : "secondary"
        return  <div style={direction === "right" ? {justifyContent: "end", display: "grid"} : {justifyContent: "start", display: "grid", marginBottom: "10px"}}>
          <div className='item-container' style={{ backgroundColor: "#fff", borderRadius: "20px", maxWidth: "70vw", padding: "5px 10px", textAlign: "center", color: "#000"}}>
            <span style={{fontSize: "16px", fontWeight: '500'}}>{element.message}</span>
          </div>
          <div style={direction === "right" ? {justifyContent: "end", display: "grid"} : {justifyContent: "start", display: "grid"}}>
            <span style={{opacity: '40%', fontSize: "12px", fontWeight: "600", color: '#000'}}>{element.time}</span>
          </div>
        </div>
      }))
    return msgElement;
  }

  function doRefresh(event: CustomEvent<RefresherEventDetail>) {
    window.location.replace('./Inbox');
    event.detail.complete();
  }

  const handleNewMessage = () => {
    // console.log("TEXT", text);
    if (text !== '') {
      checkConversations();
    } else {
      toastStore.getState().setToast('Type a message first!');
    }
  }

  const handleReply = () => {
    let args = {
      body: text,
      fromUsername: userInfo.driverCode,
      conversationId: activeMsg.messageId,
    }
    sendMessage(args);
    resetForm();
  }

  function resetForm() {
    setText('');
    setSubject('');
    setType('');
    setNewMessage(false);
  }

  function loadMore($event: CustomEvent<void>) {
    if (Object.keys(activeMsg).length !== 0) {
      openMessage(activeMsg);
      ($event.target as HTMLIonInfiniteScrollElement).complete();
    }
  }

  return (
    <IonPage>
        <IonHeader>
            <IonToolbar color="primary">
                <Toolbar pageName="Inbox"/>
            </IonToolbar>
        </IonHeader>
        <IonContent id="inbox" fullscreen color="light">
            <IonModal isOpen={showMessage} cssClass='my-custom-class'>
            { !newMessage ? <>
              <IonHeader>
                <IonToolbar color="primary">
                  <IonButtons slot="start">
                    <IonButton slot="start" style={{padding: 0}}><p style={{fontFamily: "Montserrat, sans-seriff"}} onClick={() => {setShowMessage(false); setSqlQueryStart(0); setMsgData([]); setMsgHistory([]); activeMsg = {}}}>Back</p></IonButton>
                  </IonButtons>
                  <IonTitle>{activeFromUserArray.map(function(fromUsername: any) {return `${activeFromUserArray.indexOf(fromUsername) === activeFromUserArray.length - 1 ? fromUsername.name : fromUsername.name + ", "}`})}</IonTitle>
                </IonToolbar>
              </IonHeader>
                  <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent pullingIcon={refreshOutline} pullingText="Pull to refresh" refreshingSpinner="circles"></IonRefresherContent>
                  </IonRefresher>
                  <div style={{display: "grid", height: "90%"}}>
                    <div style={{"width": "100%", padding: "4% 4% 0%", height: '100%'}}>
                      <IonContent style={{width: "100%"}}>
                        <div style={{height: "10px", marginTop: "50px", pointerEvents: "none"}} >
                          <IonInfiniteScroll style={{height: "0px !important"}} threshold='20px' position='top' id='infiniteScroll' onIonInfinite={(e: CustomEvent<void>) => {window.scrollTo(0, 500); loadMore(e); console.log("firing here");}}>
                            <IonInfiniteScrollContent loading-spinner='dots' loadingText="Fetching messages..."></IonInfiniteScrollContent>
                          </IonInfiniteScroll>
                        </div>
                        <InboxMessageBox msgArray={msgData}/>
                      </IonContent>
                    </div>
                  </div>
                  <IonItem lines="none" color="#212121">
                    <div className='item-container' style={{display: "flex"}}>
                      <div className="inbox-input">
                        <input id="issues" className="input" type="text" placeholder="Reply" value={text} onChange={e => setText(e.target.value!)}/>
                        {/* <p className="placeholder" >Reply</p> */}
                      </div>
                      <img src={arrowImg} width={"20px"} style={{margin: "auto 10px 30px"}} onClick={e => {handleReply()}}></img>
                    </div>
                  </IonItem>
                </>
                :
                <>
                <IonHeader>
                  <IonToolbar color="primary">
                    <IonButtons slot="start">
                      <IonButton style={{ padding: 0}} onClick={ function() { setShowMessage(false); setNewMessage(false)}}>
                        <IonIcon slot="icon-only" icon={chevronBackOutline} />
                      </IonButton>
                    </IonButtons>
                    <IonTitle>New Message</IonTitle>
                  </IonToolbar>
                </IonHeader>
                <IonContent>
                <IonItem lines="none" color="light">
                  <div className='item-container' style={{height: "100vh"}}>
                    <div>
                      <p className="subtitle">To:</p>
                      <select name="Contact" className="input" value={newToUser} onChange={e => setNewToUser(e.target.value!)}>
                        <option value={"driver manager"}>DM</option>
                        <option value={"Western Safety Department"}>Safety</option>
                        <option value={"Western Fuel Department"}>Fuel</option>
                        <option value={"Western Human Resources"}>HR</option>
                        <option value={"Western Payroll"}>Payroll</option>
                        <option value={"Western Breakdown Department"}>Breakdown</option>
                        <option value={"Western Extended Coverage"}>Ext. Coverage</option>
                      </select>
                    </div>
                    <div style={{display: "flex"}}>
                      <div className="input-container-msg">
                        <textarea id="issues" className="input-text-area" placeholder="Type Message" value={text} onChange={e => setText(e.target.value!)}></textarea>
                        {/* {text === "" ? <p className="placeholder">Type Here</p> : null} */}
                      </div>
                      <div style={{alignContent: "center"}} onClick={e => {handleNewMessage(); handleEventLog("mail_send", "submit-thruOutbox")}}>
                        <img src={arrowImg} width={"20px"} style={{margin: "22px 10px 0px"}}></img>
                      </div>
                    </div>
                    {/* <p onClick={e => {handleNewMessage(); handleEventLog("mail_send", "submit-thruOutbox")}}>Send</p> */}
                  </div>
                </IonItem>
                  {/* <IonItem lines="none" >
                    <IonTextarea placeholder="Type here..." style={{width: "calc(100% - 50px)", flex: "0 1 auto", marginTop: "25px", backgroundColor: "#f8f8f8", borderRadius: "15px", paddingLeft: "10px", paddingRight: "10px", marginLeft: '20px'}} autoGrow={false} value={text} onIonChange={e => setText(e.detail.value!)}></IonTextarea>
                      <IonIcon slot="icon-only" icon={send} onClick={e => {handleNewMessage(); handleEventLog("mail_send", "submit-thruOutbox")}}/>

                  </IonItem> */}
                </IonContent>
                </> 
                }
            </IonModal>

            <div ref={ref} className="main" onClick={() => close()}>
            <div className="messageList">
              <IonRefresher className="refresher" slot="fixed" pullMin={80} onIonRefresh={doRefresh} closeDuration="2000ms">
                <IonRefresherContent pullingIcon={refreshOutline} pullingText="Pull to refresh" refreshingSpinner="circles"></IonRefresherContent>
              </IonRefresher>
              <IonList id="messageList" style={{marginBottom: "20%"}}>
                {messages.map(function(msg: any) {
                  return <div style={{backgroundColor: "#FFF", padding: "8px", borderBottom: "1px solid #0000003f", height: "100px"}} onClick={() => {openMessage(msg);setShowMessage(true);}}>
                    <IonLabel className="message-content">
                      <div style={{display: "grid", gridTemplateColumns: "80% 20%", padding: " 5px 5px 10px"}}>
                        <div style={{display: "grid"}}>
                          <strong style={{marginBottom: "20px"}}>{msg.fromUsernameArray.map(function(fromUsername: any) {return `${msg.fromUsernameArray.indexOf(fromUsername) === msg.fromUsernameArray.length - 1 ? fromUsername.name : fromUsername.name + ", "}`})}</strong>
                          <span style={{color: '#000', lineHeight: '1.5', margin: "auto auto", opacity: "0.7"}}>{msg.lastMessage.slice(0, 50) + "..."}</span>
                        </div>
                        <div style={{display: "grid"}}>
                          <div style={msg.unreadMessage ? {height: "13px", width: "13px", background: "#99cc00", borderRadius: "20px", margin: "auto"} : {background: "transparent", height: "15px", width: "15px", borderRadius: "20px"}}></div> 
                          <span style={{color: "#0000007f", fontSize: "10px", fontWeight: '600', margin: "auto", textAlign: "center"}}>{msg.time}</span>
                        </div>
                      </div>
                    </IonLabel>
                  </div>
                })}
                {messages.length === 0 ? <IonItem lines="none">
                    <div style={{width: "100%", textAlign: "center"}}>
                  <h5><b>No Messages</b></h5>
                </div></IonItem>: null}
              </IonList>
              </div>
            </div>
        </IonContent>
            <div style={{position: "relative", zIndex: "99"}}>
              <button id="new_message" onClick={e => {setShowMessage(true); setNewMessage(true)}}>
                <strong style={{fontSize: "14px", color: "white"}}>New Message <strong style={{fontSize: "20px"}}>|</strong></strong>
                <IonIcon icon={createOutline} />
              </button>
            </div>
          <IonFooter>
            <Nav pageName="Inbox" onSearch={()=> handleMode(true)}/>
          </IonFooter>
    </IonPage>

  );
};

export default Inbox;
